// src/utils/dateUtils.js
import dayjs from 'dayjs';

export const getValidTz = () => {
  const rawTz = localStorage.getItem('timeZone');
  return (rawTz && rawTz !== 'null' && rawTz !== 'undefined') ? rawTz : null;
};

export const getTodayInTz = () => {
  const tz = getValidTz();
  if (!tz) return dayjs().format('YYYY-MM-DD');
  const result = new Date().toLocaleDateString('en-CA', { timeZone: tz });
  return result;
  
};